import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/ads/importer/adsImporterActions';

export default importerReducers(actions);
